/**
 * Format signup/account phone input to E.164 (matches backend shared/phone_utils.py).
 * @param {string} raw - digits-only or mixed input
 * @returns {string|null}
 */
export function formatPhoneToE164(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const cleanNumber = raw.replace(/\D/g, '');
  if (cleanNumber.length < 10 || cleanNumber.length > 15) return null;
  if (cleanNumber.length === 10) return `+1${cleanNumber}`;
  if (cleanNumber.length === 11 && cleanNumber.startsWith('1')) return `+${cleanNumber}`;
  return `+${cleanNumber}`;
}

/**
 * @param {string} raw
 * @returns {boolean}
 */
export function isValidSignupPhone(raw) {
  return formatPhoneToE164(raw) != null;
}
